<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/g07mq7/tc-custom/9780547999258.jpg?1736882624929" alt="This image is the cover for the book Last Train to Zona Verde"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Last Train to Zona Verde
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The acclaimed author of <i>Dark Star Safari</i> journeys across western Africa in this “thoroughly engrossing [and] at times tragic” travelogue (<i>Washington Post</i>).</b></p><p>Paul Theroux’s best-selling <i>Dark Star Safari</i> chronicled his epic overland voyage from Cairo to Cape Town, providing an insider’s look at modern Africa. Now, with <i>The Last Train to Zona Verde</i>, he returns to discover how both he and Africa have changed in the ensuing years. Traveling alone, Theroux sets out from Cape Town, going north through South Africa, Namibia, then into Angola, encountering a world increasingly removed from tourists’ itineraries and the hopes of postcolonial independence movements. </p><p>After covering nearly 2,500 arduous miles, Theroux cuts short his journey, a decision he chronicles with unsparing honesty in a chapter titled “What Am I Doing Here?” Vivid, witty, and beautifully evocative, <i>The Last Train to Zona Verde</i> is a fitting final African adventure from the writer whose gimlet eye and effortless prose have brought the world to generations of readers. </p><b>“If this book is proof, age has not slowed Theroux or encouraged him to rest on his achievements . . . Gutsy, alert to Africa's struggles, its injustices and history.” — <i>San Francisco Chronicle</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul Theroux
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4623a6bd